import getApiClient from '@/plugins/api'
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"

const moment = require('moment')

export default {
    checkAccess() {

    },

    getTripCover(trip) {
        if (trip && trip.cover) {
            const baseUrl = process.env.VUE_APP_BASE_URL

            return `${baseUrl}/assets/img/fb_imgs/${trip.cover}`
        }
    },

    changePage: function(page) {
        this.page = page
    },

    loadTrips() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.$store.commit('startLoading')

        self.searchParams.page = self.page
        self.searchParams.itemsPerPage = self.perPage

        // Time filter
        self.searchParams['startTime[after]'] = null
        self.searchParams['startTime[before]'] = null
        self.searchParams[`startTime[${self.searchParams.timeTrips}]`] = new Date()
        self.searchParams[`order[startTime]`] = self.searchParams.timeTrips === 'after' ? 'asc' : 'desc'

        api.get('trips', {
            params: self.searchParams
        })
            .then((result) => {
                self.trips = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)

                self.checkOrders()
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    checkOrders() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.trips.forEach(trip => {
            api.get(`orders`, {
                params: {
                    'trip.id': trip.id,
                    status: 3
                }
            })
                .then((ordersResult) => {
                    self.orders[trip.id] = ordersResult.data['hydra:member'];
                    self.blockRemoval[trip.id] = ordersResult.data['hydra:totalItems'] > 0;

                    if (self.orders[trip.id].length > 0) {
                        this.passengers[trip.id] = [];

                        self.orders[trip.id].map((order) => {
                            order.travelers.map((traveler) => {
                                this.passengers[trip.id].push(traveler);
                            });
                        });
                    }
                })
                .catch((error) => {
                })
                .finally(() => {
                    self.$store.commit('stopLoading')
                })
        })
    },

    confirmDeleteTrip(tripId) {
        this.currentTripDelete = tripId
        this.notDelete = this.blockRemoval[tripId] ? true : false
        this.showDeleteConfirmation = true
    },

    cancelTripDelete() {
        this.currentTripDelete = null
        this.showDeleteConfirmation = false
    },

    deleteTrip() {
        const self = this,
            api = getApiClient(self.$root.$store),
            tripId = self.currentTripDelete

        self.$store.commit('startLoading')

        self.searchParams.page = self.page
        self.searchParams.itemsPerPage = self.perPage

        api.delete(`trips/${tripId}`)
            .then(() => {
                self.loadTrips()
                self.currentTripDelete = null
                self.showDeleteConfirmation = false
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    setPlace: function(data) {
        this.searchParams['place.id'] = data.value
    },

    resetPlace: function() {
        this.searchParams['place.id'] = null
    },

    vacancyTrip(trip) {
        this.showVacancy = true
        this.currentAccommodations = trip.accommodations
        this.currentTrip = trip
    },

    cancelVacancyTrip() {
        this.showVacancy = false
        this.currentAccommodations = null
        this.currentTrip = null
    },

    saveVacancyTrip() {
        const self = this
        const api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')

        self.currentTrip.accommodations = self.currentAccommodations

        const data = self.reduceTripData()

        api.patch(`/trips/${this.currentTrip.id}/update_vacancies`, data,{
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then((result) => {
                self.currentAlertSuccessVacancy = 5;
                self.loadTrips()
            })
            .catch((error) => {
                self.currentAlertDangerVacancy = 5;
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    reduceTripData() {
        const trip = _.cloneDeep(this.currentTrip)
        const reduceTrip = {accommodations: []};

        trip.accommodations.forEach((accommodation) => {
            reduceTrip.accommodations.push({
                "@id": `/trip_accommodations/${accommodation.id}`,
                "currentId": accommodation.id,
                "vacancies": Number(accommodation.vacancies)
            })
        })

        return reduceTrip
    },

    generatePassengerList(tripId) {
        let trip = this.trips.filter((trip) => {
            return trip.id === tripId
        });

        trip = trip[0];

        let passengers = this.passengers[tripId];

        let pdf = new jsPDF();
        let body = [];
        let finalX = 14;
        let finalY = 5;
        let imageLogo = new Image();

        imageLogo.src = 'img/logo.webp'

        pdf.setFillColor(5, 16, 78);
        pdf.rect(0, 0, 220, 25, "F");

        pdf.addImage(imageLogo, 'png', finalX, finalY + 2, 30, 12)

        finalY = finalY + 30;

        pdf.text(String(trip.eventTitle).substring(0, 58), finalX, finalY);

        finalY = finalY + 10;

        pdf.text(
            `Inicio: ${moment(trip.startTime).format("DD/MM/YYYY")} / Fim: ${moment(trip.stopTime).format("DD/MM/YYYY")}`,
            finalX,
            finalY
        );

        if (passengers) {
            passengers.map((passenger) => {
                let cpf = passenger.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4');

                body.push([passenger.name, cpf, passenger.rg]);
            });
        }

        finalY = finalY + 5;

        autoTable(pdf, { html: '#table' });

        autoTable(pdf, {
            startY: finalY,
            head: [['Nome', 'CPF', 'RG']],
            body: body,
            styles: {
              fontSize: 10,
              cellWidth: 'wrap'
            },
            headStyles: {
                fillColor: [42, 26, 185],
            },
            columnStyles: {
              cellWidth: 'auto'
            }
        });

        pdf.save(`Passageiros - ${trip.eventTitle}.pdf`);
    },

    openOrdersForTrip(tripId) {
        const route = this.$router.resolve({
            name: 'Pedidos',
            query: { trip: tripId }
        })
        window.open(route.href, '_blank')
    }
}
